export const dateToUnixTime = (dateString) => {
  const date = new Date(dateString);
  const unixTimeMilliseconds = date.getTime();

  return unixTimeMilliseconds;
};
